<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-block">
                <form @submit="resetPassword">
                  <h1>Reset password</h1>
                  <p class="text-muted">Type your email to get reset password link</p>
                  <div class="input-group mb-3">
                    <span class="input-group-addon"><i class="icon-envelope" /></span>
                    <input
                      v-model="email"
                      type="text"
                      class="form-control"
                      placeholder="Your email"
                    >
                  </div>

                  <div class="input-group">
                    <button type="button" class="btn btn-primary px-4 login-btn" @click="resetPassword">
                      Send email
                      <span v-if="loading" class="btn-loader" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div v-if="errors" class="card card-inverse card-danger">
            <div class="card-header">
              Errors
            </div>
            <div class="card-block">
              {{ errors }}
            </div>
          </div>
          <div v-if="isRequestSuccess" class="card card-inverse card-success">
            <div class="card-header">
              Thank you
            </div>
            <div class="card-block">
              Please check your inbox for password reser link
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

export default {
  data: () => ({
    isRequestSuccess: false,
    email: '',
    loading: false,
    errors: null,
  }),

  mounted() {
    if (localStorage.getItem(this.$config.tokenStorage.name) !== '') {
      const tokenStorage = JSON.parse(localStorage.getItem(this.$config.tokenStorage.name));
      if (!_.isEmpty(tokenStorage)) {
        this.$router.push('/admin');
      }
    }
  },

  methods: {
    isFormValid() {
      if (!this.email) {
        this.errors = 'Please pass email field.';
        return false;
      }
      return true;
    },
    resetPassword() {
      if (this.loading) return;
      if (!this.isFormValid()) return;
      this.loading = true;
      axios.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}password/create`, {
        email: this.email,
      },
      {
        headers: {
          'Content-Type': 'application/json; charset=UTF-8',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.errors = null;
          this.isRequestSuccess = true;
        })
        .catch((e) => {
          this.isRequestSuccess = false;
          this.errors = e.message;
          console.error(e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// RequestResetPassword.vue?1616cbfe